import gql from 'graphql-tag';

export const getProfessors = gql`
  query getProfessors {
    coursesApp {
      schedule {
        id
        name
        code
        period
        professors {
          firstName
          lastName
        }
      }
    }
  }
`;
